import { useEffect } from 'react'
import UserInfoTop from '../../components/UserInfoTop/UserInfoTop'
import styles from './Giveway.module.css'
import GivewayHeader from './GivewayHeader/GivewayHeader'
import GivewayList from './GivewayList/GivewayList'
import GivewayTopInfo from './GivewayTopInfo/GivewayTopInfo'
import type { WebApp } from '../../types/telegram';

interface ExtendedWebApp extends WebApp {
  contentSafeAreaInset?: {
    top: number;
    bottom: number;
    left: number;
    right: number;
  };
}

const GivewayPage = () => {

    useEffect(() => {
        const tg = window.Telegram?.WebApp as ExtendedWebApp;
        if (!tg) return;
    
        const apply = () => {
          const top = tg?.contentSafeAreaInset?.top ?? 0;
          document.documentElement.style.setProperty(
            '--tg-viewport-content-safe-area-inset-top',
            `${top}px`,
          );
        };
    
        apply();
        tg.onEvent?.('contentSafeAreaChanged', apply);
        return () => tg.offEvent?.('contentSafeAreaChanged', apply);
      }, []);

    return (
        <div className={styles.container}>
            <GivewayHeader/>
            <GivewayTopInfo/>
            <GivewayList/>
        </div>
    )
}

export default GivewayPage